import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import {
  FREE_SHIPPING_COPY,
  FLAT_SHIPPING_COPY,
  DELIVERY_WINDOW_COPY,
  SHIPPING_REGION_COPY,
  RETURN_CONDITION_COPY,
} from "@/lib/shipping";
import { PAYMENT_PARTNER_COPY } from "./PaymentPartnerNote";

/** Shipping, returns and payment facts, all from the verified policy source. */
export const PolicyAccordion = () => (
  <Accordion type="single" collapsible className="border-t border-border mb-7">
    <AccordionItem value="shipping">
      <AccordionTrigger className="text-[13px] uppercase tracking-[0.15em]">Shipping & delivery</AccordionTrigger>
      <AccordionContent className="text-[13px] text-muted-foreground leading-relaxed space-y-2">
        <p>{FREE_SHIPPING_COPY}. {FLAT_SHIPPING_COPY}.</p>
        <p>Delivery: {DELIVERY_WINDOW_COPY}.</p>
        <p>{SHIPPING_REGION_COPY}</p>
        <Link to="/shipping" className="underline underline-offset-2 hover:text-foreground">Shipping details</Link>
      </AccordionContent>
    </AccordionItem>
    <AccordionItem value="returns">
      <AccordionTrigger className="text-[13px] uppercase tracking-[0.15em]">Returns</AccordionTrigger>
      <AccordionContent className="text-[13px] text-muted-foreground leading-relaxed space-y-2">
        <p>Return within 30 days of delivery. {RETURN_CONDITION_COPY}</p>
        <p>Return shipping is yours to cover, unless the item arrived damaged, defective or incorrect.</p>
        <Link to="/returns" className="underline underline-offset-2 hover:text-foreground">Returns policy</Link>
      </AccordionContent>
    </AccordionItem>
    <AccordionItem value="payment">
      <AccordionTrigger className="text-[13px] uppercase tracking-[0.15em]">Payment</AccordionTrigger>
      <AccordionContent className="text-[13px] text-muted-foreground leading-relaxed">
        <p>{PAYMENT_PARTNER_COPY}</p>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
);
